"use client"
import { useEffect, useState } from "react"
import { Menu, LogOut } from "lucide-react"
import { Button } from "../ui/button"
import { Avatar, AvatarFallback } from "../ui/avatar"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu"

import { auth, db } from "../../firebaseconfig"
import { onAuthStateChanged, signOut } from "firebase/auth"
import { doc, getDoc } from "firebase/firestore"
import { useNavigate } from "react-router-dom"

export default function DashboardHeader({ toggleSidebar }) {
  const [userData, setUserData] = useState(null)
  const navigate = useNavigate()

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        const docRef = doc(db, "users", user.uid)
        const docSnap = await getDoc(docRef)
        if (docSnap.exists()) {
          setUserData(docSnap.data())
        }
      } else {
        setUserData(null)
      }
    })

    return () => unsubscribe()
  }, [])

  const getInitials = () => {
    if (!userData) return ""
    const first = userData.firstName?.charAt(0).toUpperCase() || ""
    const last = userData.lastName?.charAt(0).toUpperCase() || ""
    return `${first}${last}`
  }

  const handleLogout = async () => {
    await signOut(auth)
    navigate("/")
  }

  return (
    <header
  className="sticky top-0 z-30 flex h-16 items-center justify-between border-b bg-white px-4 sm:px-6"
  style={{
    paddingTop: "env(safe-area-inset-top)",
  }}
>

      <Button variant="ghost" size="icon" className="lg:hidden" onClick={toggleSidebar}>
        <Menu className="h-6 w-6" />
        <span className="sr-only">Toggle menu</span>
      </Button>

      <div className="flex-1"></div>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <div className="flex items-center gap-2 cursor-pointer">
            <Avatar className="h-8 w-8">
              <AvatarFallback className="bg-[#003226] text-white">
                {getInitials()}
              </AvatarFallback>
            </Avatar>
            <span className="text-sm font-medium text-[#003226] hidden sm:inline">
              {userData ? `${userData.firstName} ${userData.lastName}` : ""}
            </span>
          </div>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>
            {userData ? `${userData.firstName} ${userData.lastName}` : "Usuario"}
          </DropdownMenuLabel>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={handleLogout}>
            <LogOut className="mr-2 h-4 w-4" /> Cerrar sesión
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </header>
  )
}
